import Vue from "vue"
export function changeProject(oldProjectId, newProjectId) {
  const store = Vue.prototype.$store
  let projectId = store.getters.projectId
  if (projectId == oldProjectId) {
    return newProjectId
  }
  return projectId
}
